import { IIconBase } from '..'

const historyCreateIcon = ({
  color = '#DAF9F2',
  height = 32,
  width = 32,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_ddd_5316_116608)'>
        <rect x='4' y='3' width='24' height='24' rx='12' fill={color} />
        <path
          d='M12.9867 19.2333L15.0533 20.8333C15.32 21.1 15.92 21.2333 16.32 21.2333H18.8533C19.6533 21.2333 20.52 20.6333 20.72 19.8333L22.32 14.9667C22.6533 14.0333 22.0533 13.2333 21.0533 13.2333H18.3867C17.9867 13.2333 17.6533 12.9 17.72 12.4333L18.0533 10.3C18.1867 9.7 17.7867 9.03333 17.1867 8.83333C16.6533 8.63333 15.9867 8.9 15.72 9.3L12.9867 13.3667'
          stroke='#131523'
          strokeWidth='1.5'
          strokeMiterlimit='10'
        />
        <path
          d='M9.58667 19.2333V12.7C9.58667 11.7667 9.98667 11.4333 10.92 11.4333H11.5867C12.52 11.4333 12.92 11.7667 12.92 12.7V19.2333C12.92 20.1667 12.52 20.5 11.5867 20.5H10.92C9.98667 20.5 9.58667 20.1667 9.58667 19.2333Z'
          stroke='#131523'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <filter
          id='filter0_ddd_5316_116608'
          x='0'
          y='0'
          width='32'
          height='32'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5316_116608'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.272 0 0 0 0 0.294667 0 0 0 0 0.34 0 0 0 0.12 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_5316_116608'
            result='effect2_dropShadow_5316_116608'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1'
            operator='dilate'
            in='SourceAlpha'
            result='effect3_dropShadow_5316_116608'
          />
          <feOffset />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.596078 0 0 0 0 0.630065 0 0 0 0 0.698039 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_5316_116608'
            result='effect3_dropShadow_5316_116608'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect3_dropShadow_5316_116608'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default historyCreateIcon
